import api from "./axios";

// ⚡ Nuevo endpoint para dashboard-summary
export const getDashboardSummaryNew = async () => {
  try {
    const { data } = await api.get("/dashboard/dashboard-summary");
    return data;
  } catch (err) {
    console.error("Error llamando a dashboard-summary:", err);
    return null;
  }
};
